import React, { useState } from "react";

const CategoriesManager = () => {
  const [categories, setCategories] = useState(["reviews", "interviews", "news"]);
  const [newCategory, setNewCategory] = useState("");

  const addCategory = (e) => {
    e.preventDefault();
    if (newCategory.trim() && !categories.includes(newCategory.trim())) {
      setCategories([...categories, newCategory.trim()]);
      setNewCategory("");
    }
  };

  const removeCategory = (cat) => {
    setCategories(categories.filter((c) => c !== cat));
  };

  return (
    <div>
      <h3 className="mb-4">🏷️ Διαχείριση Κατηγοριών</h3>
      <form onSubmit={addCategory} className="d-flex mb-3">
        <input
          type="text"
          placeholder="Νέα κατηγορία"
          className="form-control me-2"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
        />
        <button type="submit" className="btn btn-success">
          Προσθήκη
        </button>
      </form>

      <ul className="list-group">
        {categories.map((cat, i) => (
          <li
            key={i}
            className="list-group-item bg-dark text-white d-flex justify-content-between align-items-center"
          >
            {cat}
            <button
              className="btn btn-danger btn-sm"
              onClick={() => removeCategory(cat)}
            >
              Διαγραφή
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoriesManager;
